<template>
    <div>
        <Popup v-model="popupShow" closeable close-icon-position="top-right" @close="close" style="width: 90%">
            <NavBar title="开始处理"/>
            <Field
                    clearable
                    v-model="taskItemDeal.result"
                    label="勘查结论"
                    required
                    right-icon="arrow-down"
                    placeholder="请选择勘查结论"
                    :rules="[{ required: true, message: '勘查结论不为空' }]"
                    @click-right-icon="selectResult"
            />
            <div style="display:flex;justify-content : space-between;width:90%;margin:auto;">
                <UploadImage
                        :imageList="onImage1"
                        style="margin-top:5px;margin-left:-15px"
                        top="勘查图1"
                        type="SafetyImage"
                        @imageChange="image1Change"
                        :count="1"
                        edit
                />
                <UploadImage
                        :imageList="onImage2"
                        style="margin-top:5px;margin-left:-15px"
                        top="勘查图2"
                        type="SafetyImage"
                        @imageChange="image2Change"
                        :count="1"
                        edit
                />
                <UploadImage
                        :imageList="onImage3"
                        style="margin-top:5px;margin-left:-15px"
                        top="勘查图3"
                        type="SafetyImage"
                        @imageChange="image3Change"
                        :count="1"
                        edit
                />
                <UploadImage
                        :imageList="onImage4"
                        style="margin-top:5px;margin-left:-15px"
                        top="勘查图4"
                        type="SafetyImage"
                        @imageChange="image4Change"
                        :count="1"
                        edit
                />
            </div>
            <Button type="info" block style="width: 90% ; margin: 10px auto;" @click="submit">确定</Button>
        </Popup>
        <SelectResult :data="resultList"  :show="resultPanel"  @ok="onResult"  @cancel="resultPanel=false"/>
    </div>
</template>

<script>
    import { Popup, NavBar, Field, Button} from "vant"
    import UploadImage from "@/components/UploadImage";
    import {downloadImg} from "@/config"
    import SelectResult from "@/components/SelectPopup/SelectResult";


    export default {
        components: { SelectResult,Popup, Field, Button, NavBar, UploadImage},
        props: {
            taskItemDeal: {type: Object, required: true},
            type: {type: String, default: "default"},
            show: {type: Boolean, default: false}
        },
        data() {
            return {
                popupShow: false,
                resultList:[],
                resultPanel:false
            };
        },
        computed: {
            onImage1() {
                return this.taskItemDeal.image1 ? [this.taskItemDeal.image1] : []
            },
            onImage2() {
                return this.taskItemDeal.image2 ? [this.taskItemDeal.image2] : []
            },
            onImage3() {
                return this.taskItemDeal.image3 ? [this.taskItemDeal.image3] : []
            },
            onImage4() {
                return this.taskItemDeal.image4 ? [this.taskItemDeal.image4] : []
            }
        },
        created() {
            this.popupShow = this.show
        },
        mounted() {
            console.info("11111",this.taskItemDeal)
            this.taskResult()
        },
        methods: {
            submit() {
                this.$http.tokiot.prospect.taskItem.update(this.taskItemDeal)
                    .then(res => {
                        if (res) {
                            this.$toast.success("处理成功");
                            this.popupShow = !this.popupShow
                            this.$emit("onRefresh")
                        } else {
                            this.$toast.fail(res.message)
                        }
                    })
            },
            onResult(data){
                this.taskItemDeal.result=data.text
                this.resultPanel=false
            },
            selectResult(){
                this.resultPanel  = true
            },
            taskResult(){
                this.taskItemDeal.id&& this.$http.tokiot.prospect.taskItem.result({taskItemId:this.taskItemDeal.id})
                    .then(res=>{
                        if(res){
                            this.resultList=res.rows
                        }
                    })
            },
            image1Change(imageList) {
                this.taskItemDeal.image1 = imageList[0];
            },
            image2Change(imageList) {
                this.taskItemDeal.image2 = imageList[0];
            },
            image3Change(imageList) {
                this.taskItemDeal.image3 = imageList[0];
            },
            image4Change(imageList) {
                this.taskItemDeal.image4 = imageList[0];
            },
            close() {
                this.$emit('panel', this.type,)
            },
        },
        watch: {
            show(show) {
                this.popupShow = show
            },

        }
    }
</script>

<style scoped>

</style>